import { ISelectValues } from "./ISelectValues";

export const ID_FILTER_CUSTOMERNAME_TS = "customerName";
export const ID_FILTER_TYPE_TS = "typology";
export const ID_FILTER_THRESHOLD_FROM_TS  = "thresholdFrom";
export const ID_FILTER_THRESHOLD_TO_TS = "thresholdTo";
export const ID_FILTER_PERCENTAGE_FROM_TS  = "percentageFrom";
export const ID_FILTER_PERCENTAGE_TO_TS = "percentageTo";
export const ID_FILTER_TYPOLOGY_TS = "typology";
export const ID_FILTER_SEARCH_TS = "search";
export const ID_FILTER_THRESHOLD_LEGAL_ENTITIES = "legal-entities";
export const ID_FILTER_THRESHOLD_DEALERS = "dealers";

export const transactionType: ISelectValues[] = [
  {
    value: "TAXABLE",
    label: "thresholds.types.taxable",
  },
  {
    value: "TIME_AND_KM",
    label: "thresholds.types.time&Km",
  }
];



